import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { RegisterResponse } from '../models/register-response.model';
import { RegisterRequest } from '../models/register-request.model';
import { Observable } from 'rxjs';
import { ProductsResponse } from '../models/product.model';

@Injectable({
  providedIn: 'root'
})
export class RegisterService {

  private readonly baseUrl = environment.apiBaseUrl;

  constructor(private http: HttpClient) { }

  userAdd(payload: RegisterRequest): Observable<RegisterResponse> {
    const url = `${this.baseUrl}/user/registred`;
    return this.http.post<RegisterResponse>(url, payload);
  }

  getProducts(): Observable<ProductsResponse> {
      return this.http.get<ProductsResponse>(`${this.baseUrl}/load/products`);
    }
}
